<template>
  <page>
    <form>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="'required|start_after_today'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')" :max="new Date()"></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.form.fromDate"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
        </v-card-text>
      </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <!-- Report Type -->
                      <v-flex xs6>
                        <v-autocomplete :items="rptTypeList" v-model="form.rptType" :label="labels.rptType" item-text="label" item-value="value"
                          data-vv-name="rptType" :data-vv-as="labels.rptType" :error-messages="errors.collect('rptType')" v-validate="'required'">
                        </v-autocomplete>
                      </v-flex>
                      <!-- Policy Type -->
                      <v-flex xs12 md6>
                        <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('polType')"
                        :data-vv-as="labels.polType" data-vv-name="polType" append-icon="mdi-magnify" @click:append="multiPolTypeList = true" readonly
                        v-validate="'required'"></v-text-field>
                      </v-flex>
                      <!-- Business Class -->
                      <v-flex xs12 md6>
                        <v-text-field v-model="form.billAcctNo" :label="labels.billAcctNo" :error-messages="errors.collect('billAcctNo')"
                        :data-vv-as="labels.billAcctNo" data-vv-name="billAcctNo" append-icon="mdi-magnify" @click:append="multiBillAcctNoList = true" readonly
                        v-validate="'required'"></v-text-field>
                      </v-flex>
                      <!-- Client Type -->
                      <v-flex xs12 md6>
                        <v-text-field v-model="form.clientType" :label="labels.clientType" :error-messages="errors.collect('billAcctNo')"
                        :data-vv-as="labels.clientType" data-vv-name="clientType" append-icon="mdi-magnify" @click:append="multiClientTypeList = true" readonly
                        v-validate="'required'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <!-- Direct/RI -->
                      <v-flex xs6>
                        <v-autocomplete :items="driList" v-model="form.dri" :label="labels.dri" item-text="label" item-value="value"
                          data-vv-name="dri" :data-vv-as="labels.dri" :error-messages="errors.collect('dri')" v-validate="'required'">
                        </v-autocomplete>
                      </v-flex>
                      <!-- Policy Status -->
                      <v-flex xs6>
                        <v-autocomplete :items="polStatList" v-model="form.polStat" :label="labels.polStat" item-text="label" item-value="value"
                          data-vv-name="polStat" :data-vv-as="labels.polStat" :error-messages="errors.collect('polStat')" v-validate="'required'">
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- <v-toolbar dense card color="grey lighten-3" flat>
          <v-icon>mdi-filter</v-icon>
          <v-toolbar-title>Filters</v-toolbar-title>
        </v-toolbar> -->
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-flex lg6 xs12>
        <v-checkbox dense v-model="form.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex  xs12 class="pt-3">
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="multiPolTypeList" width="900px" lazy>
        <multi-pol-type-exclude-help-list  v-if="multiPolTypeList" :pt="form.polType" :excludePt="form.c11" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-exclude-help-list>
      </v-dialog>
      <v-dialog v-model="multiBillAcctNoList" width="900px" lazy>
        <multi-bill-acct-no-help-list  v-if="multiBillAcctNoList" :pt="form.billAcctNo" :excludePt="form.c11" @close="doClose" @doAssign="doAssignBillAcctNo($event)"></multi-bill-acct-no-help-list>
      </v-dialog>
      <v-dialog v-model="multiClientTypeList" width="900px" lazy>
        <multi-client-type-help-list  v-if="multiClientTypeList" :clientType="form.clientType" @close="doClose" @doAssign="doAssignClientType($event)"></multi-client-type-help-list>
      </v-dialog>
    </form>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import { extractMenu } from '@/utils/extract'
import MultiPolTypeExcludeHelpList from '@/components/core/common/dialog/MultiPolTypeExcludeHelpList'
import MultiBillAcctNoHelpList from '@/components/core/common/dialog/MultiBillAcctNoHelpList'
import MultiClientTypeHelpList from '@/components/core/common/dialog/MultiClientTypeHelpList'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: 'Transaction Date To*',
        rptType: 'Report Type',
        polType: 'Policy Types',
        billAcctNo: 'Billing Accounts',
        clientType: 'Client Types',
        dri: 'Direct/RI',
        polStat: 'Policy Status',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      form: {
        fromDate: '',
        toDate: '',
        rptType: 'All',
        polType: 'All',
        billAcctNo: 'All',
        clientType: 'All',
        dri: 'D',
        polStat: 'R',
        printRptRunTime: true
      },
      polTypeList: [],
      billAcctList: [],
      menu: {},
      rptTypeList: [
        { label: 'All', value: 'All' },
        { label: 'Policy Type', value: 'P' },
        { label: 'Billing Account', value: 'B' }
      ],
      driList: [
        { label: 'Direct only', value: 'D' },
        { label: 'Inwards only', value: 'I' },
        { label: 'Both', value: 'B' }
      ],
      polStatList: [
        { label: 'Released only', value: 'R' },
        { label: 'Unreleased only', value: 'U' },
        { label: 'Both', value: 'All' }
      ],
      submitting: false,
      // Helplist
      multiPolTypeList: false,
      multiBillAcctNoList: false,
      multiClientTypeList: false,
      panel: [0],
      panel1: [0]
    }
  },
  created() {
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
    this.doInit()
  },
  methods: {
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInit() {
      this.setMenu()
    },
    async setMenu() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.codeOfPractice
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
          // this.getPolTypeList()
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async getPolTypeList() {
      const apiURI = this.menu.getPolTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            data.map(dataMap => {
              const convertList = {
                code: dataMap.polType,
                value: dataMap.polType + ' - ' + dataMap.polTypeDesc
              }
              this.polTypeList.push(convertList)
            })
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doClose() {
      this.multiPolTypeList = false
      this.multiBillAcctNoList = false
      this.multiClientTypeList = false
    },
    doAssignPolType(Obj) {
      this.form.polType = ''
      this.form.polType = Obj.finalSelectedItems.toString()
    },
    doAssignBillAcctNo(Obj) {
      this.form.billAcctNo = ''
      this.form.billAcctNo = Obj.finalSelectedItems.toString()
    },
    doAssignClientType(Obj) {
      this.form.clientType = ''
      this.form.clientType = Obj.finalSelectedItems.toString()
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      // result.push(reportFormat.PDF)
      result.push(reportFormat.XLSX)
      return result
    },
    codeOfPracticeMenu() {
      return this.$store.state.reports.custom1Reports.codeOfPractice.menu
    },
    toDateValidation() {
      const result = 'required|from_to_date:' + this.form.fromDate
      return result
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiPolTypeExcludeHelpList,
    MultiBillAcctNoHelpList,
    MultiClientTypeHelpList
  }
}
</script>
